import globals from '../../globals/communityGlobals';
import { ValidationTypes } from '../ValidationTypes';

export const ValidateNHSCodeModule = nhsNumber => {
  const locale = globals.getAreas(['error']);

  let nhsNumberErrorMessage = null;

  if (nhsNumber) {
    nhsNumber = nhsNumber.replace(/ /g, '');
  }

  if (isNaN(nhsNumber || nhsNumber === null)) {
    nhsNumberErrorMessage = locale.getMsg(ValidationTypes.NHSvalidation.errorLabels[0]);
  } else if (nhsNumber.length > 0 && nhsNumber.length !== ValidationTypes.NHSvalidation.maxCodeLength) {
    nhsNumberErrorMessage = locale.getMsg(ValidationTypes.NHSvalidation.errorLabels[1]);
  } else {
    nhsNumberErrorMessage = null;
  }

  return { nhsNumber, nhsNumberErrorMessage };
};
